<template>
  <b-modal id="show_hours_modal" ref="show_hours_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <!-- Different modal header depending on type file being uploaded for -->
        <h1><i class="fas fa-clock"></i> TIMESHEET HOURS</h1>
        <p id="mh-info">Hours for {{ $store.state.client_timesheets.hours_modal.first_name }} {{ $store.state.client_timesheets.hours_modal.surname }}
        </p>
      </div>

      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <div class="row">
      <div class="col-12" v-for="h in $store.state.client_timesheets.hours_modal.hours">
        <div class="cardLabel" style="width: 175px; display: inline-block;"><strong>{{ day_name(h.pay_date) }}</strong></div>
        <div class="cardLabel" style="width: 50px; display: inline-block;">{{ h.hours_total }}</div>

        <div v-if="h.timesheet_clock.length > 0" class=" d-inline-block">
          (<span v-for="(c, k, i) in h.timesheet_clock">{{ c.clock_time }}<span v-if="k < h.timesheet_clock.length - 1"> - </span></span>)
        </div>
      </div>
    </div>

  </b-modal>
</template>

<script>
export default {
  name: "show_hours",
  methods: {
    day_name(date) {
      return this.$moment.utc(date).format('dddd DD/MM/YYYY')
    },
    hideModal() {
      this.$refs.show_hours_modal.hide();
      this.$store.commit('HIDE_HOURS_MODAL');
    }
  }
}
</script>
